import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-24",
  "use": "icon-24-usage",
  "viewBox": "0 0 16.818 17",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16.818 17\" id=\"icon-24\"><defs><style> </style></defs><path class=\"a\" d=\"M310.771,979.677l.743-3.428H296.971a1.672,1.672,0,0,1-1.343-.714,4.011,4.011,0,0,0-.557.786,3.007,3.007,0,0,0-.329.929,2.251,2.251,0,0,0,.286,1.686,1.6,1.6,0,0,0,1.286.743h4.914l-2.314,12.857h3.514l2.314-12.857\" transform=\"translate(-294.695 -975.534)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol